module.exports = __webpack_public_path__ + "static/media/culture-bg.0f325747.svg";